import React, { useState, useEffect, useRef } from 'react';
import MarkdownExtended from './MarkdowmExtended';
import { chunkArray } from '@lib/utils/stringUtils';

interface DelayTextComponentProps {
    text: string;
    totalTime: number; // Total approximate time in milliseconds
    initialDelay: number; // Initial delay before starting in milliseconds
    useMarkdown?: boolean; // Optional flag to render with MarkdownExtended
}

export const DelayTextComponent: React.FC<DelayTextComponentProps> = ({
    text,
    totalTime,
    initialDelay,
    useMarkdown = false,
}) => {
    const [displayedText, setDisplayedText] = useState('');
    const isFinishedRef = useRef(false);

    useEffect(() => {
        // Reset displayed text when text prop changes
        setDisplayedText('');

        const charArray = [...text];
        const chunkedText = chunkArray(charArray, text.length / 100);
        // Break text into parts
        const parts: string[] = chunkedText.map(chunk => chunk.join(""))

        setTimeout(() => {
            // If no parts, just show the text immediately after initial delay
            if (parts.length === 0) {
                setDisplayedText(text);
            }

            // Calculate approximate delay per part with some randomization
            const baseDelay = totalTime / parts.length;
            const variationRange = baseDelay * 0.4; // ±40% variation

            let accumulatedText = '';
            let currentTime = initialDelay;

            // Schedule each part to be displayed
            const timeouts: NodeJS.Timeout[] = [];

            accumulatedText = ":thumbsup: OK!"
            const initialSpace = setTimeout(() => {
                setDisplayedText(":thumbsup: OK!");
            }, 0);

            timeouts.push(initialSpace);

            parts.forEach((part, index) => {
                accumulatedText += part;
                const textToShow = accumulatedText;

                // Add random variation to the delay
                const randomVariation = (Math.random() - 0.5) * 2 * variationRange;
                const delay = Math.max(150, baseDelay + randomVariation); // Minimum 50ms delay

                currentTime += delay;

                const timeout = setTimeout(() => {
                    if (index == parts.length - 1) {
                        isFinishedRef.current = true
                    }
                    setDisplayedText(textToShow)
                }, currentTime);

                timeouts.push(timeout);
            });

            // Cleanup function to clear all timeouts
            return () => {
                timeouts.forEach(timeout => clearTimeout(timeout));
            };
        }, initialDelay)

    }, [text, totalTime, initialDelay]);

    if (isFinishedRef.current)
        return useMarkdown ? <MarkdownExtended sessionId='' text={text} /> : <>{text}</>

    if (useMarkdown) {
        return <MarkdownExtended sessionId='' text={displayedText} />;
    }

    return <>{displayedText}</>;
};

export default DelayTextComponent;

